import { useEffect } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { SafeArea } from 'capacitor-plugin-safe-area';

export default function MobileLayout() {
    const navigate = useNavigate();
    const location = useLocation();
    const isNative = Capacitor.isNativePlatform();

    useEffect(() => {
        // Handle Hardware Back Button on Android
        if (isNative) {
            App.addListener('backButton', ({ canGoBack }) => {
                if (location.pathname === '/pcm/tecnico/home' || location.pathname === '/pcm/operador' || location.pathname === '/' || location.pathname === '/login') {
                    App.exitApp();
                } else if (canGoBack) {
                    window.history.back();
                } else {
                    App.exitApp();
                }
            });
        }

        return () => {
            if (isNative) {
                App.removeAllListeners();
            }
        };
    }, [isNative, location.pathname]);

    return (
        <div className={`min-h-screen bg-slate-50 ${isNative ? 'pt-[env(safe-area-inset-top)] pb-[env(safe-area-inset-bottom)]' : ''}`}>
            {/* 
                We can add a global mobile header here if needed, 
                but usually pages have their own headers.
                This layout mainly handles Safe Area and Back Button.
             */}
            <Outlet />
        </div>
    );
}
